<template>
  <div>
    <h4 class="mt-4 font-weight-bold text-secondary">
      <i class="fas fa-money-check"></i> รายได้
    </h4>
    <label><i class="fas fa-calendar-alt"></i> เลือกเดือน</label>
    <div><date-picker class="w-100" value-type="YYYY-MM-DD" v-model="revenueDate" type="month" format="MM/YYYY" placeholder="เลือกเดือน"></date-picker></div>
    <!-- <b-form-datepicker v-model="revenueDate" :min="min" :max="max" locale="th" placeholder="เลือกเดือน" :date-format-options="{ year: 'numeric', month: '2-digit' }"></b-form-datepicker> -->
    <b-alert variant="primary" class="text-center mt-3" show>รายได้ ระบบแนะนำ จะถอนเข้าเป็นเงินเครดิต หากสงสัยโปรดติดต่อเอเย่นต์ที่ท่านสมัครสมาชิก</b-alert>
    <h5 class="text-secondary font-weight-bold text-center">{{formatDate(revenueDate, "MMMM YYYY")}}</h5>
    <div class="w-100 my-2 border-bottom"></div>
    <div class="d-flex flex-row mb-2 w-100" v-for="(item,index) in items" v-bind:key="index">
      <div class="table-secondary border rounded-left p-2 d-inline w-50 mr-0">{{item.transactionDate}}</div>
      <div class="bg-white border rounded-right text-right text-sm-right text-md-left p-2 d-inline w-50 ml-0">฿ {{item.amount.toLocaleString()}}</div>
    </div>
    <div class="d-flex flex-row mb-2 w-100">
      <div class="table-success border rounded-left p-2 d-inline w-50 mr-0">ยอดรวม (เดือน)</div>
      <div class="bg-white border rounded-right text-right text-sm-right text-md-left p-2 d-inline w-50 ml-0">฿ {{totalRevenue.toLocaleString()}}</div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import DatePicker from 'vue2-datepicker';

export default {
  name: "Revenue",
  components: {
    DatePicker
  },
  data() {
    return {
      revenueDate: moment(new Date()).format('YYYY-MM-DD'),
      items: [
      ]
    };
  },
  mounted() {
    this.getResult();
  },    
  methods: {
    getResult() {
      console.log("this.revenueDate",this.revenueDate);
      axios.post(this.getApiUrl + "/affiliate/revenue",
        {
          transactionDate: this.revenueDate,
          CustomerCode: this.getUsername,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        })
        .then(response => {
          this.items = response.data.data;
          console.log('items', this.items);
        });
    },
    formatDate(dt,format) {
      if(dt === null) {
        return moment().format(format);
      }
      else {
        return moment(String(dt)).format(format);
      }
    }        
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getApiUrl: "getApiUrl"
    }),    
    totalRevenue() {
        return this.items.reduce((acc, item) => acc + item.amount, 0);
      }
  },
  watch: {
    revenueDate() {
      this.getResult();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>